import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class SmartSyncService extends RequestBase {
    BasePath = 'api/smartsync/';

    GetUseCases(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetUseCases', this.options);
    }

    GetUseCase(id: string): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetUseCase?id=' + id, this.options);
    }

    GetFieldValues(query: any): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + 'GetFieldValues', query, this.options);
    }

    CheckExistsTable(dataSource: string, tableName: string): Observable<any> {
        const path = this.API_BASE_URL + this.BasePath + 'CheckExistsTable?dataSource=' + dataSource + '&tableName=' + tableName;
        return this.http.get<any>(path, this.options);
    }

    SaveAndStartUseCase(query: any): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + 'SaveAndStartUseCase', query, this.options);
    }

    GetSavedUseCases(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetSavedUseCases', this.options);
    }
}
